export const teamsBorderRadius = '3px';
export const teamsButtonBorderRadius = '2px';
